import {
  Modal,
  Box,
  Paper,
  Typography,
  TextField,
  InputAdornment,
  IconButton,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Divider,
  Chip,
} from "@mui/material";
import { useTheme } from "@mui/system";
import useStyles from "./styles";
import { useEffect, useState } from "react";
import { CloseOutlined, Visibility, VisibilityOff } from "@mui/icons-material";
import api from "../../../../../../services/api";
import usePermissoesDoCliente from "../hooks/usePermissoesDoCliente";
import VirtualizedAutocomplete from "../../../../../../components/virtualization/virtualizedAutocomplete";
import {
  CampoCliente,
  renderOpcaoCliente,
} from "../../../../../../components/opcaoCliente";
import { getClienteOptionLabel } from "../../../../../../components/grupoEconomico/helpers";

// Permissão global do sistema, existe em todos os clientes
const PERMISSAO_ADM = "ADM";

export default function ModalAddUserClient({
  open,
  setOpenModalAddUser = () => {},
  setNewUserClient = () => {},
  createUserCliente = () => {},
  createButton,
  newUserCliente,
  setSnackbar = () => {},
  clientes = [],
}) {
  const [showPass, setShowPass] = useState(false);
  const [emailValido, setEmailValido] = useState(false);

  const [selectCliente, setSelectCLiente] = useState("");
  const [Null, setNull] = useState(false);
  const [senhaValid, setSenhaValid] = useState(false);
  const theme = useTheme();
  const styles = useStyles(theme);
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  // O estado guarda só o id do cliente (é o que alimenta as permissões do
  // portal); o objeto vem da lista de options porque o campo precisa dele
  // para montar o selo PF/PJ.
  const clienteSelecionado =
    clientes.find((cliente) => cliente?.id === selectCliente) || null;

  // As permissões do portal são por cliente: a lista acompanha o cliente selecionado
  const { permissoes } = usePermissoesDoCliente({
    clienteId: selectCliente,
    enabled: open,
  });

  // Ao trocar o cliente a permissão anterior pode não existir no novo cliente.
  // Nesse caso cai no ADM, que é global e existe para todos os clientes.
  useEffect(() => {
    if (!permissoes?.length) return;

    const escolhida =
      permissoes.find(
        (permissao) => permissao?.codigoPermissao === newUserCliente?.permissao,
      ) ||
      permissoes.find(
        (permissao) => permissao?.codigoPermissao === PERMISSAO_ADM,
      ) ||
      permissoes[0];

    setNewUserClient((prev) => ({
      ...prev,
      permissao: escolhida?.codigoPermissao || "",
      permissaoId: escolhida?.id || "",
      // Guardado aqui porque a lista de permissões vive só neste modal: o
      // componente pai precisa da cor para exibir o chip sem esperar um refetch
      permissaoColor: escolhida?.color || "",
    }));
  }, [permissoes]);

  /* 	useEffect(() => {
		getClientes();
	}, []); */

  useEffect(() => {
    if (emailRegex.test(newUserCliente?.email)) {
      setEmailValido(true);
    } else {
      setEmailValido(false);
    }
  }, [newUserCliente?.email]);
  useEffect(() => {
    if (
      newUserCliente?.senha?.length >= 6 &&
      /[a-zA-Z]/.test(newUserCliente?.senha) &&
      /\d/.test(newUserCliente?.senha)
    )
      setSenhaValid(true);
    else setSenhaValid(false);
  }, [newUserCliente?.senha]);

  const handleCreateUser = () => {
    if (
      !newUserCliente?.email ||
      !newUserCliente?.login ||
      !newUserCliente?.senha ||
      !newUserCliente?.email ||
      !newUserCliente?.cliente ||
      !emailValido ||
      !senhaValid
    ) {
      setNull(true);
      setSnackbar({
        children: "Necessário preencher todos os campos",
        severity: "error",
      });
    } else {
      setNull(false);
      setSelectCLiente("");
      createUserCliente();
    }
  };

  /* const getClientes = async () => {
		try {
			const response = await api.get("/interno/clientes");
			setClientes(response?.data);
		} catch {
			setSnackbar({
				children: "Não foi possivel buscar os clientes",
				severity: "error",
			});
		} finally {
		}
	}; */
  const handleCancelar = () => {
    setSelectCLiente("");
    setOpenModalAddUser(false);
    setNull(false);
    setSelectCLiente("");
    setNewUserClient({
      login: "",
      email: "",
      senha: "",
      cliente: "",
      permissao: "",
      permissaoId: "",
      permissaoColor: "",
    });
  };

  return (
    <Modal
      sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
      open={open}
      onClose={handleCancelar}
    >
      <Paper sx={styles.container}>
        <Box sx={styles.containerForm}>
          <Box sx={styles.containerTitulo}>
            <Typography variant="title">Cadastro de usuário</Typography>
            <IconButton onClick={handleCancelar}>
              <CloseOutlined />
            </IconButton>
          </Box>
          <Divider sx={{ mb: 2 }} />
          <Box sx={styles.containerSelect}>
            <VirtualizedAutocomplete
              size="small"
              disablePortal
              options={clientes}
              value={clienteSelecionado}
              getOptionLabel={(option) =>
                getClienteOptionLabel(option)
              }
              sx={styles.textfield}
              onChange={(event, cliente) => {
                setSelectCLiente(cliente?.id);
                // Ao trocar o cliente a permissão volta para ADM, que é global
                // e existe para todos os clientes
                setNewUserClient((prev) => ({
                  ...prev,
                  cliente: cliente?.id,
                  permissao: PERMISSAO_ADM,
                }));
              }}
              renderOption={renderOpcaoCliente()}
              renderInput={(params) => (
                <CampoCliente
                  params={params}
                  option={clienteSelecionado}
                  variant="filled"
                  label="Cliente"
                />
              )}
            />
          </Box>

          <TextField
            label="Login"
            id="login"
            variant="filled"
            color="primary"
            size="small"
            sx={styles.textfield}
            autoComplete="off"
            onChange={(e) =>
              setNewUserClient((prev) => ({ ...prev, login: e?.target?.value }))
            }
            helperText={
              !newUserCliente?.login && Null
                ? "Necessário informar um login"
                : ""
            }
            error={!newUserCliente?.login && Null}
          />
          <TextField
            label="Email"
            id="email"
            variant="filled"
            type="email"
            size="small"
            color="primary"
            sx={styles.textfield}
            autoComplete="off"
            onChange={(e) =>
              setNewUserClient((prev) => ({ ...prev, email: e?.target?.value }))
            }
            helperText={
              (!newUserCliente?.email || !emailValido) && Null
                ? "Necessário informar um e-mail válido"
                : ""
            }
            error={(!newUserCliente?.email || !emailValido) && Null}
          />

          <TextField
            autoComplete="off"
            name="senha"
            label="Senha"
            size="small"
            variant="filled"
            color="primary"
            sx={styles.textfield}
            type={showPass ? "text" : "password"}
            onChange={(e) =>
              setNewUserClient((prev) => ({ ...prev, senha: e?.target?.value }))
            }
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    edge="end"
                    onClick={() => setShowPass((event) => !event)}
                  >
                    {showPass ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            helperText={
              (!newUserCliente?.senha || !senhaValid) && Null
                ? "A senha precisa ter no mínimo 6 digítos, uma letra e um número."
                : ""
            }
            error={(!newUserCliente?.senha || !senhaValid) && Null}
          />

          <FormControl
            variant="filled"
            size="small"
            sx={styles.TextField}
            fullWidth
          >
            <InputLabel>Permissão</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              value={newUserCliente?.permissao || ""}
              label="Permissão"
              onChange={(event) => {
                const escolhida = permissoes?.find(
                  (permissao) =>
                    permissao?.codigoPermissao === event?.target?.value,
                );
                setNewUserClient((prev) => ({
                  ...prev,
                  permissao: event?.target?.value,
                  permissaoId: escolhida?.id || "",
                  permissaoColor: escolhida?.color || "",
                }));
              }}
              renderValue={(selected) => (
                <Chip
                  label={selected?.toUpperCase()}
                  size="small"
                  sx={{
                    fontWeight: "bold",
                    color: theme.palette.white.main,
                    backgroundColor:
                      newUserCliente?.permissaoColor ||
                      "chip.main.waitingReview",
                  }}
                />
              )}
              name="status"
              color="primary"
            >
              {Array.isArray(permissoes) &&
                permissoes?.map((permissao) => (
                  <MenuItem
                    key={permissao?.id}
                    value={permissao?.codigoPermissao}
                  >
                    <Chip
                      label={permissao?.codigoPermissao?.toUpperCase()}
                      size="small"
                      sx={{
                        fontWeight: "bold",
                        color: theme.palette.white.main,
                        backgroundColor:
                          permissao?.color || "chip.main.waitingReview",
                      }}
                    />
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Box>
        <Box sx={styles.containerButtons}>
          <Button
            disabled={createButton}
            variant="contained"
            size="large"
            sx={{ borderRadius: "10px", height: "40px", mr: 2 }}
            onClick={handleCreateUser}
          >
            Cadastrar
          </Button>
        </Box>
      </Paper>
    </Modal>
  );
}
